import React, { Component } from "react";

import { withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import Loader from "../general/Loader";
import { formatCurrency, getLink } from "../../utils/helpers";
import { debounce } from "lodash";
import Transaccion from "./Transaccion";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { METODOS_PAGO } from "../../utils/types";

const queryDeFiltros = (filtros) =>
	Object.keys(filtros)
		.map((fil) => `${fil}=${filtros[fil]}`)
		.join("&");

class Transacciones extends Component {
	state = {
		transacciones: {},
		transaccion: {},
		links: null,
		meta: null,
		loading: true,
		filtros: [],
		filtrosQuery: "",
		showCreate: false,
	};
	componentDidMount() {
		this.getTransacciones();
	}
	getTransacciones = async (url = null) => {
		const id = this.props.cuenta.id;
		url = url
			? "transacciones?cuenta_id=" + id + "&" + url
			: "transacciones?cuenta_id=" + id + "&";
		const transacciones = await this.props.request(url);

		if (transacciones.data) {
			this.setState({
				transacciones: transacciones.data,
				links: transacciones.links,
				meta: transacciones.meta,
				loading: false,
			});
		}
	};
	// `await this.setState()` no espera al re-render: setState no devuelve una
	// promesa, así que la continuación se reanudaba antes de que React
	// aplicara el update y `this.state.filtros` tenía los filtros anteriores.
	// Por eso cada consulta salía un filtro atrás y el primer intento no
	// filtraba nada. El estado se actualiza con la forma funcional y la consulta
	// se lanza en el callback de setState, que sí corre después del commit.
	onFiltroChange = (value, filtro) => {
		this.setState((state) => {
			const filtros = { ...state.filtros, [filtro]: value };

			return { filtros, filtrosQuery: "?" + queryDeFiltros(filtros) };
		}, this.buscarConFiltros);
	};
	// El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
	// era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
	// descartaba el primero junto con su valor.
	buscarConFiltros = debounce(() => {
		const query = queryDeFiltros(this.state.filtros);

		this.getTransacciones(query);
	}, 500);

	toggleCreateModal = () => {
		this.setState({
			showCreate: !this.state.showCreate,
		});
	};

	render() {
		const { transacciones, loading, filtrosQuery } = this.state;
		const { cuenta, toggleEditModal } = this.props;
		return (
			<div>
				<div className="row m-t-40 m-b-20">
					<h3 className="col m-t-10">Historial de Movimientos</h3>
					<div className="col text-right">
						<Link
							to={getLink(
								`/imprimir/cuentas/${cuenta.id}/transacciones${
									filtrosQuery ?? ""
								}`
							)}
							target="_blank"
							className="au-btn-filter m-r-15"
						>
							<i className="zmdi zmdi-print" /> Imprimir
						</Link>
						<button
							className="au-btn au-btn-icon au-btn--green au-btn--small m-r-10"
							onClick={toggleEditModal}
						>
							<i className="zmdi zmdi-edit" />
							Editar
						</button>
						<button
							className="au-btn au-btn-icon au-btn--green au-btn--small"
							onClick={this.toggleCreateModal}
						>
							<i className="zmdi zmdi-swap" />
							Nueva Transacción
						</button>
					</div>
				</div>

				<div className="page-controls">
					<div className="table-data__tool">
						<div className="table-data__tool-left row">
							<div className="col">
								<label>Buscar</label>
								<input
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"buscar"
										)
									}
									type="search"
									placeholder="Buscar..."
									className="form-control"
									name="buscar"
								/>
							</div>
							<div className="col-md-2">
								<label htmlFor="estado">Tipo</label>
								<select
									className="form-control"
									name="tipo"
									id="tipo"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"tipo"
										)
									}
								>
									<option value="todos">Todos</option>
									<option value="CREDITO">Crédito</option>
									<option value="DEBITO">Débito</option>
								</select>
							</div>
							<div className="col-md-2">
								<label htmlFor="forma_pago">Forma de Pago</label>
								<select
									className="form-control"
									name="forma_pago"
									id="forma_pago"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"forma_pago"
										)
									}
								>
									<option value="todas" selected>Todas</option>
                                    {METODOS_PAGO.map((metodo) => (
                                        <option key={metodo.value} value={metodo.value}>
                                            {metodo.label}
                                        </option>
                                    ))}
								</select>
							</div>
							<div className="col-md-2">
								<label htmlFor="desde">Desde</label>
								<input
									type="date"
									className="form-control"
									name="desde"
									id="desde"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"desde"
										)
									}
								/>
							</div>
							<div className="col-md-2">
								<label htmlFor="hasta">Hasta</label>
								<input
									type="date"
									className="form-control"
									name="hasta"
									id="hasta"
									onChange={(e) =>
										this.onFiltroChange(
											e.target.value,
											"hasta"
										)
									}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div>
							{loading && <Loader />}
							{!transacciones.length ? (
								<div>
									{!loading && (
										<div>
											Todavía no hay transacciones
											registradas para esta cuenta.
										</div>
									)}
								</div>
							) : (
								<div className="table-data">
									<table className="table table-data2">
										<thead>
											<tr>
												<th>Fecha</th>
												<th>No. Transacción</th>
												<th>Tipo</th>
												<th>Forma de Pago</th>
												<th>Concepto</th>
												<th>Realizada Por</th>
												<th className="text-right">
													Monto
												</th>
												<th
													style={{ width: "100px" }}
												></th>
											</tr>
										</thead>
										<tbody>
											{transacciones.map(
												(transaccion) => {
                                                    const formaPagoIcon = {
                                                        'efectivo': 'fas fa-money-bill-alt',
                                                        'transferencia': 'fas fa-exchange-alt',
                                                        'tarjeta-debito': 'fas fa-credit-card',
                                                        'tarjeta': 'fas fa-credit-card',
                                                        'cheque': 'fas fa-money-check',
                                                    }[transaccion.forma_pago] || 'fas fa-university';
                                                    return (
													<tr
														className="tr-shadow"
														key={transaccion.id}
													>
														<td>
															{dayjs(transaccion.fecha).format("DD/MM/YYYY") + " " + dayjs(transaccion.created_at).format("hh:mm a")}
														</td>
														<td>{transaccion.no}</td>
														<td>
															{transaccion.tipo == 'DEBITO' ? <span className="badge badge-danger badge-small">Débito</span> : <span className="badge badge-small badge-success">Crédito</span>}
														</td>
                                                        <td>
															<i className={`color-primary ${formaPagoIcon}`} style={{fontSize: '18px', marginRight: '10px'}}></i> <span className="capitalize">{transaccion.forma_pago}</span>
														</td>
														<td>
															{
																transaccion.descripcion.split("\n").map((linea, index) => (
																	<span key={index}>
																		{linea}
																		<br />
																	</span>
																))
															}
														</td>
														<td>
															{
																transaccion.realizadaPor
															}
														</td>
														<td className="text-right">
															{formatCurrency(
																transaccion.monto,
																cuenta.moneda
															)}
														</td>
														<td>
                                                            <div className="table-data-feature">
                                                                <Link
                                                                    to={getLink(
																		`/imprimir/cuentas/${cuenta.id}/transacciones/${transaccion.id}`
																	)}
                                                                    target="_blank"
                                                                    className="item d-none d-sm-inline"
                                                                    title="Imprimir"
                                                                >
                                                                    <i className="fas fa-print"></i>
                                                                </Link>
                                                            </div>
														</td>
													</tr>
												)}
											)}
										</tbody>
									</table>
									{this.state.links && (
										<Pagination
											links={this.state.links}
											meta={this.state.meta}
											getData={this.getTransacciones}
										/>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
				<Modal
					show={this.state.showCreate}
					blank={true}
					toggle={this.toggleCreateModal}
				>
					<Transaccion
                        toggle={this.toggleCreateModal}
                        cuenta={cuenta}
                        cuentas={this.props.cuentasForForm}
                        getCuentas={this.props.getCuentas}
						getTransacciones={this.getTransacciones}
                    />
				</Modal>
			</div>
		);
	}
}

export default withRequest(Transacciones);
